<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'"
            ref="content">
            <Row style="margin-bottom: 20px">
                <label v-if="active != 'cusWeChat'">项目名称</label>
                <Select v-if="active != 'cusWeChat'"
                    v-model="filter.projId"
                    clearable
                    placeholder="全部"
                    :disabled="loading"
                    :class="preCls + 'select-public-style'">
                    <Option v-for="(item, index) in projList"
                        :key="index"
                        :value="item.id">{{item.projName}}</Option>
                </Select>
                <label>开始日期</label>
                <date-picker :disabled="loading"
                    :class="preCls + 'select-public-style'"
                    v-model="startDate"
                    transfer
                    type="date"></date-picker>
                <label>结束日期</label>
                <date-picker :disabled="loading"
                    :class="preCls + 'select-public-style'"
                    v-model="endDate"
                    transfer
                    type="date"></date-picker>
                <check-tag-group style="display: inline-block;"
                    v-model="near"
                    color="primary">
                    <check-tag :disabled="loading"
                        v-for="(item, index) in nearList"
                        style="height: 32px; line-height: 32px"
                        :name="item.id"
                        :key="index">{{item.text}}</check-tag>
                </check-tag-group>
            </Row>
            <Tabs :animated="false"
                v-model="active">
                <TabPane label="微信客户"
                    :index="1"
                    name="cusWeChat">
                    <Access name="cusWeChat">
                        <router-view v-if="active == 'cusWeChat'"
                            :filter="filter"
                            :name="$access.aliasToUri('cusWeChat')"></router-view>
                    </Access>
                </TabPane>
                <TabPane label="预约登记"
                    :index="2"
                    name="cusRegister">
                    <Access name="cusRegister">
                        <router-view v-if="active == 'cusRegister'"
                            :filter="filter"
                            noticeType="1"
                            :name="$access.aliasToUri('cusRegister')"></router-view>
                    </Access>
                </TabPane>
                <TabPane label="变价通知"
                    :index="3"
                    name="cusPrice">
                    <Access name="cusPrice">
                        <router-view v-if="active == 'cusPrice'"
                            :filter="filter"
                            noticeType="2"
                            :name="$access.aliasToUri('cusPrice')"></router-view>
                    </Access>
                </TabPane>
                <TabPane label="开盘通知"
                    :index="4"
                    name="cusNotice">
                    <Access name="cusNotice">
                        <router-view v-if="active == 'cusNotice'"
                            :filter="filter"
                            noticeType="3"
                            :name="$access.aliasToUri('cusNotice')"></router-view>
                    </Access>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>
<script>
import { projList } from '@/api/proj-manager'
import dayjs from 'dayjs'

export default {
    data() {
        return {
            projList: [],
            filter: {
                projId: this.$cache.projId,
                startDate: this.$cache.startDate || dayjs().format("YYYY-MM-DD"),
                endDate: this.$cache.endDate || dayjs().format("YYYY-MM-DD"),
            },
            searchWidth: 100,
            active: 'cusWeChat',
            loading: false,
            nearList: [{
                    id: 7,
                    text: '近7天'
                },
                {
                    id: 30,
                    text: '近30天'
                },
                {
                    id: 90,
                    text: '近90天'
                }
            ]
        }
    },
    computed: {
        startDate: {
            get() {
                return this.filter.startDate ? new Date(this.filter.startDate) : ''
            },
            set(val) {
                this.filter.startDate = val ? dayjs(val).format("YYYY-MM-DD") : ''
            }
        },

        endDate: {
            get() {
                return this.filter.endDate ? new Date(this.filter.endDate) : ''
            },
            set(val) {
                this.filter.endDate = val ?  dayjs(val).format("YYYY-MM-DD") : ''
            }
        },

        near: {
            get() {
                return [dayjs(this.filter.endDate).diff(this.filter.startDate, 'day')]
            },
            set(val) {
                let days = val[0]

                if (days) {
                    this.filter.endDate = dayjs().format('YYYY-MM-DD')
                    this.filter.startDate = dayjs()
                        .subtract(days, 'day')
                        .format('YYYY-MM-DD')
                }
            },
        }
    },
    watch: {
        "filter.projId": function(el) {
            this.$cache.projId = el
        },
        "filter.startDate": function(el) {
            this.$cache.startDate = el
        },
        "filter.endDate": function(el) {
            this.$cache.endDate = el
        },
    },
    mounted() {
        this.loading = true
        let body = {
            page: 1,
            pageSize: 999
        }
        projList(body)
            .then(res => {
                this.projList = res.data.page.list
            })
            .finally(() => (this.loading = false))
        this.searchWidth = parseInt(
            (this.$refs.content.clientWidth) * 0.16
        )
    }
}
</script>
<style lang="less"
    scoped>
</style>